import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import EventPackageForm from './EventPackageForm'

const EventPackageEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.eventpackages.editPackage'}>
      <Edit>
        <EventPackageForm />
      </Edit>
    </SectionWrapper>
  )
}

export default EventPackageEdit
